var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('el-button',{attrs:{"type":"danger","plain":"","size":"mini","id":"logout"},on:{"click":_vm.logout}},[_vm._v(" Log out ")]),_c('div',[_c('router-view')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"id":"logo","src":"/imgs/logo_new.png","alt":""}})])
}]

export { render, staticRenderFns }